import { UnifiedDigestRecapMode } from 'src/types/unifiedDigest';

/** Shared route policy for page selection and navigation of old email links. */
export const isLegacyClarityRoute = (params: URLSearchParams): boolean =>
  params.get('view') === 'legacy' ||
  (params.has('processingId') &&
    !params.has('recapMode') &&
    params.get('scopeMode') !== 'chat_spaces');

/**
 * Keep the primary recap separate from historical source-digest deep links.
 * Old delivery links include a processing ID but predate recapMode. Changing
 * the rollout default must not reinterpret those saved source reports.
 */
export function resolveClarityView(
  params: URLSearchParams,
  revampExperience: boolean,
  hasSelectedChatScope: boolean,
): {
  recapMode?: UnifiedDigestRecapMode;
  isLegacyView: boolean;
  invalidMode: boolean;
} {
  if (!revampExperience) {
    return { isLegacyView: true, invalidMode: false };
  }

  const requestedMode = params.get('recapMode');
  const invalidMode =
    requestedMode !== null &&
    requestedMode !== 'source_activity' &&
    requestedMode !== 'action_recap';
  const requestedScope = params.get('scopeMode');
  const invalidScope =
    requestedScope !== null &&
    requestedScope !== 'workspace' &&
    requestedScope !== 'chat_spaces';
  const incompatibleScope =
    requestedMode === 'action_recap' && hasSelectedChatScope;
  const isLegacyView =
    params.get('view') === 'legacy' ||
    (!hasSelectedChatScope && isLegacyClarityRoute(params));
  const missingChatScope =
    params.get('scopeMode') === 'chat_spaces' && !hasSelectedChatScope;

  // Invalid explicit intent must be surfaced by the page, not silently used
  // for a workspace-wide Action read. Room links always retain room scope.
  if (invalidMode || invalidScope || incompatibleScope || missingChatScope) {
    return { isLegacyView, invalidMode: true };
  }

  return {
    recapMode:
      hasSelectedChatScope || isLegacyView
        ? 'source_activity'
        : (requestedMode ?? 'action_recap'),
    isLegacyView,
    invalidMode: false,
  };
}
